import React, { useState } from 'react';
import { ListGroup, Collapse } from 'react-bootstrap';
import ImageThumbnail from 'components/ImageThumbnail';
import { PromotionalProduct } from 'lib/types';
import _ from 'lodash';

interface IPromotionProductsListMobileProps {
    items: PromotionalProduct[];
    selectedCount: Map<PromotionalProduct, number[]>;
    makeCountInputs: (product: PromotionalProduct) => React.ReactNode;
}

const PromotionProductsListMobile = ({ items, selectedCount, makeCountInputs }: IPromotionProductsListMobileProps) => {
    const [selectedProduct, setSelected] = useState(-1);

    return (
        <ListGroup variant='flush' className='mb-3'>
            {_.map(items, (product, productIndex) => (
                <ListGroup.Item
                    key={product.symKar}
                    className={
                        `block-item${selectedCount.get(product)?.some((num) => num !== 0) ? ' PromotionProducts-selected-row' : ''
                        }${selectedProduct === productIndex ? ' rotate' : ''}`
                    }
                    onClick={(event) => {
                        event.stopPropagation();
                        setSelected(selectedProduct !== productIndex ? productIndex : -1);
                    }}
                >
                    <p className='PromotionProducts-photo-desc text-left clearfix'>
                        <span className='PromotionProducts-photo-td float-left'>
                            <ImageThumbnail
                                src={product.photo}
                                alt=''
                                aria-describedby={`PromotionProducts-desc-${product.symKar}`}
                            />
                        </span>
                        <span id={`PromotionProducts-desc-${product.symKar}`} className='PromotionProducts-desc d-flex flex-column justify-content-center'>
                            {product.description}
                            <div className='PromotionsProducts-price-points d-flex justify-content-around'>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    <b>Punkty: </b>
                                    {product.points.toLocaleString('fr-FR')}
                                </div>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    <b>Cena: </b>
                                    {product.price.toFixed(2)}
                                </div>
                            </div>
                            <Collapse in={selectedProduct === productIndex}>
                                <section>
                                    <div className='d-flex flex-column'>
                                        {makeCountInputs(product)}
                                    </div>
                                </section>
                            </Collapse>
                        </span>

                    </p>
                </ListGroup.Item>
            ))}
        </ListGroup>
    );
};

export default PromotionProductsListMobile;
